import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';
import { Megaphone, ChevronRight } from 'lucide-react';

export default function AgentCampaignsPage() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadCampaigns();
  }, []);

  const loadCampaigns = async () => {
    try {
      setLoading(true);
      
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) return;

      // Récupérer TOUTES les campagnes
      const { data: campaignsData, error: campaignsError } = await supabase
        .from('campaigns')
        .select('*')
        .order('created_at', { ascending: false });

      if (campaignsError) throw campaignsError;

      // Pour chaque campagne, compter les leads de l'agent
      const campaignsWithLeads = await Promise.all(
        (campaignsData || []).map(async (campaign) => {
          const { count, error } = await supabase
            .from('leads')
            .select('*', { count: 'exact', head: true })
            .eq('campaign_id', campaign.id)
            .eq('assigned_to', user.id);

          if (error) throw error;

          return {
            ...campaign,
            leads_count: count || 0
          };
        })
      );

      // Filtrer pour ne garder que les campagnes avec au moins 1 lead
      const filteredCampaigns = campaignsWithLeads.filter(c => c.leads_count > 0);
      
      console.log('Campagnes avec leads:', filteredCampaigns);
      setCampaigns(filteredCampaigns);
      
    } catch (error) {
      console.error('Erreur chargement campagnes:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 p-8 flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Mes campagnes</h1>
        <p className="text-gray-600 mb-8">Sélectionnez une campagne pour voir vos leads</p>

        {campaigns.length === 0 ? (
          <div className="bg-white rounded-xl shadow-sm p-12 text-center">
            <Megaphone className="w-16 h-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Aucune campagne avec leads</h3>
            <p className="text-gray-500">Vous n'avez pas encore de leads assignés dans des campagnes.</p>
          </div>
        ) : (
          <div className="grid gap-4">
            {campaigns.map((campaign) => (
              <button
                key={campaign.id}
                onClick={() => navigate(`/leads?campaign=${campaign.id}`)}
                className="bg-white rounded-xl shadow-sm p-6 hover:shadow-lg transition-all text-left flex items-center justify-between group"
              >
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">{campaign.name}</h3>
                  <p className="text-sm text-gray-500">
                    {campaign.leads_count} lead{campaign.leads_count > 1 ? 's' : ''} à traiter
                  </p>
                </div>
                <ChevronRight className="w-6 h-6 text-gray-400 group-hover:text-blue-600 group-hover:translate-x-1 transition-all" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
